import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_nolayout')({
    component: RouteComponent,
})

function RouteComponent() {
    
    return (
        <div className={'h-full w-full'}>
            <Outlet/>
        </div>
    )
}